<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :addComponent="componentForAdding"
      :editComponent="componentForEditing"
      :downloadPluginComponent="componentForDownloadPlugin"
      :showDetailComponent="componentForDetails"
      detailLabel="Seller Details"
      :delete_url="delete_url"
      :urls="urls"
      ref="datatable"
    >
      <template #actionsButton="{ selectedItems, refresher }">
        <div
          class="mr-md-2 mr-sm-1 mr-0 pa-0"
          :class="{ 'col-6 mx-8': $vuetify.breakpoint.xsOnly }"
        >
          <ActionsButton
            v-if="actionsButtonTypes.length > 0"
            :items="selectedItems"
            :types="actionsButtonTypes"
            :refresher="refresher"
            :class="{ 'col-6': $vuetify.breakpoint.xsOnly }"
          />
        </div>
      </template>
      <template v-slot:rowActionsDropdown="{ item }">
        <v-btn
          class="d-block w-100"
          text
          @click="
            () => {
              handleServices(item);
            }
          "
          >Services
        </v-btn>
        <v-btn
          v-if="permissionChecker('customer_license_update')"
          class="d-block w-100"
          text
          @click="
            () => {
              updateLicense(item);
            }
          "
          >Update license
        </v-btn>
      </template>
    </DataTable>
    <Services ref="services" />
    <UpdateLicense ref="updateLicense" :refresher="refresher" />
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
import ActionDialog from "@/own/components/customers/clients/ActionDialog.vue";
import DownloadPlugin from "@/own/components/customers/clients/DownloadPlugin.vue";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/clients.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ActionsButton from "@/own/components/customers/clients/ActionsButton";
import { SET_ITEM_FOR_ACTION } from "@/core/services/store/main.module";
import Services from "@/own/components/customers/clients/Services";
import ShowDetails from "@/own/components/datatable/ShowDetails.vue";
import UpdateLicense from "@/own/components/customers/clients/UpdateLicense.vue";

export default {
  name: "Clients",
  components: { UpdateLicense, DataTable, ActionsButton, Services },
  data: () => ({
    componentForEditing: ActionDialog,
    componentForAdding: ActionDialog,
    componentForDownloadPlugin: DownloadPlugin,
    componentForDetails: ShowDetails,
    delete_url: `/authorizations/clients/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getCLIENTTableFilters",
      getTableState: "getCLIENTTableState",
      getTableData: "getCLIENTTableData",
      getTableHeaders: "getCLIENTTableHeaders",
      getTableProperties: "getCLIENTTableProperties",
      getTableExportUrl: "getCLIENTExportUrl",
      getTablePermissions: "getCLIENTTablePermissions",
    },
    urls: {
      delete: `/authorizations/clients/destroy`,
      activate: `/authorizations/clients/activate`,
      status: `/authorizations/clients/status`,
      generate: "null",
      generateToken: `authorizations/clients/generate_token`,
      generateRefreshToken: `/authorizations/clients/refresh_token`,
      showUrl: `/authorizations/clients/show`,
    },
  }),
  methods: {
    refresher(item) {
      this.$refs.datatable.updateTableContent();
    },
    updateLicense(item) {
      this.$store.commit(SET_ITEM_FOR_ACTION, item);
      this.$refs.updateLicense.toggleModal();
    },
    handleServices(item) {
      this.$store.commit(SET_ITEM_FOR_ACTION, item);
      this.$refs.services.toggleModal();
    },
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
    permissionChecker(permType) {
      // console.log(this.store_names.getTablePermissions, permType);
      let result = false;
      this.$store.getters[this.store_names.getTablePermissions].forEach(
        (element) => {
          if (element.name == permType) {
            result = true;
          }
        }
      );
      return result;
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
    actionsButtonTypes: function () {
      let types = [];

      const typeNames = ["Suspend", "Unsuspend"];

      const typesUrl = ["bulk_suspend_client", "bulk_unsuspend_client"];
      const typesPermission = ["bulk_suspend_client", "bulk_unsuspend_client"];

      typesUrl.forEach((item, index) => {
        if (this.permissionChecker(typesPermission[index]))
          types.push({
            name: typeNames[index],
            url: `${item}`,
          });
      });

      return types;
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
